var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddedToLead(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.502,
    height: 15.418,
    viewBox: "0 0 18.502 15.418",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user_12613193",
    transform: "translate(0 -2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_353",
    "data-name": "Group 353",
    transform: "translate(0 11.251)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2125",
    "data-name": "Path 2125",
    d: "M12.335,20.167a.728.728,0,0,1-.771-.771V17.855a2.271,2.271,0,0,0-2.313-2.313h-5.4a2.271,2.271,0,0,0-2.313,2.313V19.4a.728.728,0,0,1-.771.771A.728.728,0,0,1,0,19.4V17.855A3.817,3.817,0,0,1,3.855,14h5.4a3.817,3.817,0,0,1,3.855,3.855V19.4A.728.728,0,0,1,12.335,20.167Z",
    transform: "translate(0 -14)",
    fill: "#2ebe0c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_354",
    "data-name": "Group 354",
    transform: "translate(2.698 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2126",
    "data-name": "Path 2126",
    d: "M7.355,9.709A3.817,3.817,0,0,1,3.5,5.855,3.817,3.817,0,0,1,7.355,2a3.817,3.817,0,0,1,3.855,3.855A3.817,3.817,0,0,1,7.355,9.709Zm0-6.167A2.271,2.271,0,0,0,5.042,5.855,2.271,2.271,0,0,0,7.355,8.167,2.271,2.271,0,0,0,9.667,5.855,2.271,2.271,0,0,0,7.355,3.542Z",
    transform: "translate(-3.5 -2)",
    fill: "#2ebe0c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_355",
    "data-name": "Group 355",
    transform: "translate(12.335 6.625)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2127",
    "data-name": "Path 2127",
    d: "M18.313,12.625a.7.7,0,0,1-.54-.231l-1.542-1.542a.763.763,0,1,1,1.079-1.079l1,1,2.544-2.544a.763.763,0,0,1,1.079,1.079l-3.084,3.084a.7.7,0,0,1-.54.231Z",
    transform: "translate(-16 -8)",
    fill: "#2ebe0c"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddedToLead);
export default __webpack_public_path__ + "static/media/added-to-lead.8508007b5bdc3a586715404a71b2726c.svg";
export { ForwardRef as ReactComponent };